import type { ApiOrdersType } from '../../../apps/api-hono/src/routes/api_orders/_router'
import { hc } from 'hono/client'
import { getEnvVariable } from '@lib/utils/getEnvVariable';
import { getClientRequestOptions } from './getClientRequestOptions';

const client = hc<ApiOrdersType>('')
type Client = typeof client

export const createStoreOrdersApiClient = (...args: Parameters<typeof hc>): Client => {
    return hc<ApiOrdersType>(...args)
}

export const storeOrdersApiClient = createStoreOrdersApiClient(
    `https://${getEnvVariable('PUBLIC_API_DOMAIN')}/orders/`,
    getClientRequestOptions()
)


